import ButtonContainer from 'core/button-container';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import icon1 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_01.svg';
import icon2 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar-SillonTV-18.svg';
import icon3 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar-CasaSillonTV-17.svg';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const InsuranceTypes = ({ culture }) => {
    const { seoText, verification } = useGetSeoTextByIndex('insurance_types');
    const t = useTranslations('insurance-types');
    const iconMap = {
        1: icon1,
        2: icon2,
        3: icon3
    };

    if (!verification) {
        return null;
    };

    const textBoxArray = useMemo(() => (
        Array.from({ length: 3 }, (_, i) => (
            <TextBox
                containerWidth="360px"
                containerHeight="auto"
                title={seoText[`item${i + 1}`].title}
                content={seoText[`item${i + 1}`].sentence1}
                image={iconMap[i + 1]}
                imageWidth={60 * (i + 1)}
                imageHeight={60}
                key={i}
            />
        ))
    ), [culture]);

    return (
        <LandingSection>
            <Title content={seoText.section_title} align tag="h2" />
            <Text content={seoText.paragraph1.sentence1} align />
            <div className="paragraph_wrapper">
                {textBoxArray}
            </div>
            <Spacer space={6} />
            <ButtonContainer>
                <FormOrRedirectButton
                    label={t('button.label')}
                    redirectWithConversio={culture === 'es-ar'}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

InsuranceTypes.propTypes = {
    culture: PropTypes.string
};

export default InsuranceTypes;
